module.exports = __webpack_public_path__ + "img/goods11_1.738aa94d.jpg";